import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyDoYNN2ajPKRM4o821VjO_snukcEYPzTOc",
  authDomain: "dudig-dd4bd.firebaseapp.com",
  projectId: "dudig-dd4bd",
  storageBucket: "dudig-dd4bd.firebasestorage.app",
  messagingSenderId: "892085324477",
  appId: "1:892085324477:web:097304f7105508ae6505d4"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);